import { create } from 'zustand';

const useSparePartSelectionStore = create((set) => ({
    selectedParts: [],
    setSelectedParts: (parts) => set({ selectedParts: parts }),
    clearSelectedParts: () => set({ selectedParts: [] }),
}));

export default useSparePartSelectionStore;
